import { css } from '@emotion/css';
import { PR10, PR30 } from '@julofinance/color-token';

export const loanWrapperCx = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  gap: 16px;
  padding: 16px;
  background: ${PR10};
  border: 1px solid ${PR30};

  .btn-change {
    padding: 0 16px;
    font-weight: bold;
    color: ${PR30};
    cursor: pointer;
  }
`;
